

import { FC } from 'react';
import { ErrorFrame } from './error-frame';

export const ErrorLoadingResources: FC = () => {
    return <ErrorFrame title={'Resources Loading Error'}>Oh, it is our problem. Try to reload the page.</ErrorFrame>;
};


import { FC } from 'react';
import { ErrorFrame } from './error-frame';

export const ErrorLoadingResources: FC = () => {
    return <ErrorFrame title={'Resources Loading Error'}>Oh, it is our problem. Try to reload the page.</ErrorFrame>;
};
